import { Controller } from 'react-hook-form';
import { InputText, SidePanelRow } from '@ui/src';
import { BrandFormTypes } from './types';
import BrandImages from './brand-images';
import BrandColors from './brand-colors';

import cn from './styles.module.css';

const BrandForm = ({
  control,
  onSubmit,
  children,
  errors,
  setValue,
  brandColor,
  companyName,
  cardLogo,
  headerLogo,
  favicon,
  loaderIcon,
}: BrandFormTypes): React.JSX.Element => (
  <form onSubmit={onSubmit} className={cn.details}>
    <SidePanelRow caption="Company Name">
      <Controller
        control={control}
        name="companyName"
        render={({ field: { onChange, value, name } }) => (
          <InputText
            placeholder="Enter company name..."
            name={name}
            value={value}
            onChange={onChange}
            error={errors?.companyName?.message}
          />
        )}
      />
    </SidePanelRow>
    <BrandImages
      setValue={setValue}
      cardLogo={cardLogo}
      headerLogo={headerLogo}
      favicon={favicon}
      loaderIcon={loaderIcon}
    />
    <BrandColors
      brandColor={brandColor}
      setValue={setValue}
      companyName={companyName}
      headerLogo={headerLogo}
    />
    {children}
  </form>
);

export default BrandForm;
